module.exports = __webpack_public_path__ + "img/EXTERIOR-JIMNY-3.6871e35a.jpg";